import useIssueStore from '@/state/issueState';
import usePrStore from '@/state/prState';
import useUserStore from '@/state/userState';
import { IssueReqInd } from '@/types/issueReqType';
import { PrReqInd } from '@/types/prReqType';
import Repository from '@/types/repositoryType';

const changeIssueForIndividual = (repository: Repository) => {
  const setIssueListInd = useIssueStore.getState().setIssueListInd;
  const user = useUserStore.getState().user;
  const issueReq: IssueReqInd = {
    UserUUID: user.UserUUID,
    RepositoryUUID: repository.UUID,
    Source: repository?.Source,
  };
  setIssueListInd(issueReq);
};

const changePrForIndividual = async (repository: Repository) => {
  const user = useUserStore.getState().user;
  const setPRListInd = usePrStore.getState().setPrListInd;
  const prReq: PrReqInd = {
    UserUUID: user.UserUUID,
    RepositoryUUID: repository.UUID,
    Source: repository?.Source,
  };
  setPRListInd(prReq);
};

const changePrAndIssueForIndividual = (repository: Repository) => {
  changeIssueForIndividual(repository);
  changePrForIndividual(repository);
};

export const setPrAndIssueForLoggedOut = (reponame: string) => {
  const setIssueListForLoggedOut =
    useIssueStore.getState().setIssueListForLoggedOut;
  const setPrListForLoggedOut = usePrStore.getState().setPrListForLoggedOut;
  setIssueListForLoggedOut(reponame);
  setPrListForLoggedOut(reponame);
};

export default changePrAndIssueForIndividual;
